const isTagValid = tag => /^@([a-z0-9_]){2,11}$/.test(tag);

export default isTagValid;
